import { render, staticRenderFns } from "./AiPreInterviewStatus.vue?vue&type=template&id=481253c2"
import script from "./AiPreInterviewStatus.vue?vue&type=script&lang=js"
export * from "./AiPreInterviewStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports